export default "__VITE_ASSET__CEAj6Du2__"